<template>
  <div class="overlay">
    <div class="sidebar" :class="{ 'sidebar--hidden': hidden }">
      <div class="sidebar__pager">
        {{ fragment }} / {{ length }}
      </div>
      <div class="sidebar__content">
        <h4>{{ title }}</h4>
        <transition name="fade" mode="out-in">
          <div :key="fragment">
            <p v-for="(line, i) in body.split('\n')" :key="i">
              {{ line }}
            </p>
          </div>
        </transition>
      </div>
    </div>
    <v-button class="sidebar-toggle" @click="toggle"
      :icon="hidden ? 'menu_open' : 'close'"
      :label="hidden ? 'Meelezen openen' : 'Meelezen sluiten'"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/Button'
import { defer } from '@/utils'

export default {
  name: 'Sidebar',
  components: {
    'v-button': Button
  },
  data () {
    return {
      hidden: true
    }
  },
  computed: {
    ...mapState({
      story: state => state.data
    }),
    title () {
      return this.story.title
    },
    body () {
      const { index, fragments } = this.story
      return fragments[index].text
    },
    fragment () {
      return this.story.index + 1
    },
    length () {
      return this.story.fragments.length
    }
  },
  methods: {
    toggle () {
      defer(100, () => {
        this.hidden = !this.hidden
      })
    }
  },
  watch: {
    hidden (isHidden) {
      const action = isHidden ? 'close_menu' : 'open_menu'
      this.track(action, { event_category: 'menu' })
    }
  }
}
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
}

.sidebar {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 32rem;
  padding: 2rem;
  background: $color-yellow url('~@/assets/images/sidebar.png') repeat-y;
  transition: transform 400ms cubic-bezier(.42, 0, .58, 1);
}

.sidebar--hidden {
  transform: translateX(100%);
}

.sidebar__pager {
  font-weight: 700;
  text-align: right;
  margin-bottom: 1.5rem;
}

.sidebar__content {
  transition: opacity 400ms ease-in;

  div {
    transition: opacity 100ms;

    &.fade-enter-active,
    &.fade-leave-active {
      opacity: 0;
    }
  }

  p {
    margin-bottom: 1.5rem;
    font-size: $text-lg;
    font-weight: 500;
    line-height: 1.4;
  }
}

.sidebar-toggle {
  position: absolute;
  bottom: 3rem;
  right: 3rem;
  z-index: 9;
}
</style>
